module.exports = __webpack_public_path__ + "img/inventory_problem.e28ae181.svg";